// is this really better than normal case? Have to-remap in components for TS
export enum RoleMutations {
  RESET = "RESET",
  SET_ROLE = "SET_ROLE",
  SET_ROLES = "SET_ROLES",
}
